import { EMPOWERING_CONSTANTS } from "./constants";
import { Stack, Flex, Image } from "@chakra-ui/react";
import { useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text } from "@/elements";
import ArchitectureImg from "public/openStack/managed-stack-architecture.png";

const EmpoweringComponent = () => {
  const TextVariant = useTextVariant();

  return (
    <Flex
      direction={{ base: "column", xl: "row" }}
      align={"center"}
      justify={"center"}
      px={8}
      py={12}
      gap={8}
    >
      <Stack
        gap={6}
        width={{ base: "100%", xl: "40%" }}
        align={{ base: "center", xl: "flex-start" }}
        textAlign={{ base: "center", xl: "left" }}
      >
        <Heading as="h1" fontWeight={"400"} fontSize={"44px"}>
          {EMPOWERING_CONSTANTS.title}
        </Heading>
        <Text variant={"body1"} fontWeight={600} color="text.100">
          {EMPOWERING_CONSTANTS.subTitle}
        </Text>
        <Text variant={TextVariant} color="text.100" lineHeight={"30px"}>
          {EMPOWERING_CONSTANTS.text}
        </Text>
      </Stack>

      <Stack width={{ base: "100%", xl: "60%" }} justify={"center"} align={"center"}>
        <Image
          src={ArchitectureImg.src}
          alt="Architecture Diagram"
          style={{ height: "auto", maxWidth: "1000px", width: "100%" }}
        />
      </Stack>
    </Flex>
  );
};

export default EmpoweringComponent;
